/**
 * A ZZJ (client action) URL is only safe to navigate to when it is a
 * well-formed absolute http/https URL. Stale/garbage values coming from the
 * backend (empty strings, relative paths, `javascript:` etc.) must not be
 * handed to the WebView bridge.
 */
export const isNavigableZzjUrl = (
	url: string | null | undefined,
): url is string => {
	if (!url) {
		return false;
	}

	const trimmed = url.trim();
	if (!trimmed) {
		return false;
	}

	try {
		const parsed = new URL(trimmed);
		return parsed.protocol === "http:" || parsed.protocol === "https:";
	} catch {
		return false;
	}
};
